/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
import { dwmRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

class DwmCreditCards {

    constructor($scope, $http, $rootScope, Util, dwmValidations) {

        $scope.creditCardNumberIsValid = true;

        const validations = dwmValidations;

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};
            if (assets.primaryMember) {

                $scope.creditDebitCards = assets.primaryMember.monitoredAccounts.creditDebitCards;
                $scope.creditDebitCards.entries.forEach((entry) => {

                    entry.showUpdateInput = false;

                });

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.showRemoveEntryScreen = false;
        $scope.showUpdateButton = false;

        $scope.addNewEntry = () => {

            $scope.newEntryVisible = true;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = true;
            setTimeout(() => {

                angular.element('.update-credit-card-number').trigger('focus');

            }, 100);

        };

        $scope.cancelNewEntry = () => {

            $scope.creditCardNumberIsValid = true;
            $scope.newEntryVisible = false;
            $scope.showAddNewButton = true;
            $scope.showSaveButton = false;
            $scope.newCreditCardNumber = '';
            $scope.newEntrySubmitted = false;

        };

        $scope.updateEntry = (index) => {

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = false;
            $scope.showUpdateButton = true;

            $scope.creditDebitCards.entries.forEach((entry, loopIndex) => {

                if (index === loopIndex) {

                    entry.showUpdateInput = true;
                    entry.cardType = 'OTHER';
                    $scope.updateEntryPayload = entry;

                    // Save initial entry values to use in case of update is canceled
                    $scope.initialCreditCardNumber = entry.cardNumber;
                    $scope.initialEntryIndex = loopIndex;

                } else {

                    entry.showUpdateInput = false;

                }

            });

            setTimeout(() => {

                angular.element('.update-credit-card-number').trigger('focus');

            }, 100);

        };

        $scope.cancelUpdateNewEntry = () => {

            $scope.creditCardNumberIsValid = true;
            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;

            $scope.creditDebitCards.entries.forEach((entry) => {

                entry.showUpdateInput = false;

            });

            $scope.updateEntryPayload = {};

            // Revert changes of the selected entry
            $scope.creditDebitCards.entries[$scope.initialEntryIndex].cardNumber =
                $scope.initialCreditCardNumber;

        };

        $scope.validateCreditCardNumber = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.creditCardNumberIsValid = $event.currentTarget.value &&
                    validations.creditCardNumberValidator($event.currentTarget.value.trim());

            }

            $scope.newCreditCardNumber = $event.currentTarget.value;

        };

        $scope.saveNewEntry = () => {

            $scope.creditCardNumberIsValid = $scope.newCreditCardNumber === undefined ? false : validations.creditCardNumberValidator($scope.newCreditCardNumber.trim());

            $scope.newEntrySubmitted = true;

            if ($scope.creditCardNumberIsValid) {

                $scope.saveNewCreditCardIsLoading = true;

                const payload = {
                    creditDebitCards: {
                        cardNumber: $scope.newCreditCardNumber,
                        cardType: 'OTHER',
                    },
                };
                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: payload,

                }).then(() => {

                    $scope.newCreditCardNumber = '';
                    $scope.saveNewCreditCardIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);

                        const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                        Mixpanel.setCommonProperty('AIA Asset Credit Card', monitoredAccounts.creditDebitCards.entries.length);

                        Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                            Action: 'Add',
                            Entry: 'Credit cards',
                        });

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        } else {

                            $rootScope.showDwmCardHomepage = false;

                        }

                        $scope.cancelNewEntry();

                    });

                }).catch((responseError) => {

                    $scope.saveNewCreditCardIsLoading = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 4013) {

                            Alert.error('cw.dwm.dupliacte_entry_error');

                        } else {

                            Alert.error(
                                { message: 'cw.recommendation.error.connection_failed' },
                                {
                                    message: {
                                        brandname: CWCONFIG.partnerConfig.name,
                                        url: '/dashboard/support/tabs/support',
                                    },
                                },
                            );

                        }

                    }

                });


            }

        };

        $scope.removeEntry = (index) => {

            $scope.showRemoveEntryScreen = true;
            $scope.cancelNewEntry();

            $scope.removeEntryPayload = {
                creditDebitCards:
                {
                    id: $scope.creditDebitCards.entries[index].id,
                },
            };

        };

        $scope.confirmRemoveEntry = () => {

            $scope.confirmRemoveIsLoading = true;

            $http({
                method: 'DELETE',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount?payload=${encodeURIComponent(JSON.stringify($scope.removeEntryPayload))}`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
            }).then(() => {

                $scope.newCreditCardNumber = '';

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                    Mixpanel.setCommonProperty('AIA Asset Credit Card', monitoredAccounts.creditDebitCards.entries.length);

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Delete',
                        Entry: 'Credit cards',
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    $scope.confirmRemoveIsLoading = false;
                    $scope.cancelRemoveEntry();
                    $scope.cancelUpdateNewEntry();

                });

            }).catch((responseError) => {

                $scope.confirmRemoveIsLoading = false;

                if (responseError.data) {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

        $scope.cancelRemoveEntry = () => {

            $scope.showRemoveEntryScreen = false;
            $scope.removeEntryPayload = {};

        };

        $scope.updateCreditCardNumber = ($event) => {

            $scope.creditCardNumberIsValid = $event.currentTarget.value && validations.creditCardNumberValidator($event.currentTarget.value.trim());

            if ($scope.creditCardNumberIsValid) {

                $scope.updateEntryPayload.cardNumber = $event.currentTarget.value;

            }

        };

        $scope.saveUpdatedEntry = () => {

            $scope.saveUpdatedEntryIsLoading = true;

            $http({
                method: 'PUT',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
                data: { creditDebitCards: $scope.updateEntryPayload },
            }).then(() => {

                Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Update',
                    Entry: 'Credit cards',
                });

                $scope.showAddNewButton = true;
                $scope.showUpdateButton = false;
                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);
                    $scope.confirmRemoveIsLoading = false;

                });

            }).catch((responseError) => {

                $scope.saveUpdatedEntryIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        Alert.error('cw.dwm.dupliacte_entry_error');

                    } else {

                        Alert.error(
                            { message: 'cw.recommendation.error.connection_failed' },
                            {
                                message: {
                                    brandname: CWCONFIG.partnerConfig.name,
                                    url: '/dashboard/support/tabs/support',
                                },
                            },
                        );

                    }

                }

            });

        };


    }

}

_serviceDependencies.push(DwmCreditCards);

angular.module('controllers')
    .controller('DwmCreditCards', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/credit-cards/credit-cards.js